import { render } from "./parrainVue.vue?vue&type=template&id=4267dd40&scoped=true"
import script from "./parrainVue.vue?vue&type=script&lang=js"
export * from "./parrainVue.vue?vue&type=script&lang=js"

import "../assets/css/animauxnew.css?vue&type=style&index=0&id=4267dd40&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4267dd40"]])

export default __exports__